import { MenuItem, TextField } from '@mui/material'
import ContentGuide from 'global/guides/ContentGuide'
import React from 'react'
import { Outlet, useOutletContext } from 'react-router-dom'
import { type FeriadosCliente, feriadosCliente } from 'service/api'
import { columns } from 'templates/Cadastro/FeriadosCliente/constants'

export default function FeriadosCliente() {
    const [ano, setAno] = React.useState(new Date().getFullYear())
    const anos = [ano - 1, ano, ano + 1]
    const { data, isLoading } = feriadosCliente.useFetch({
        queryParams: {
            ano,
        },
    })

    return (
        <ContentGuide>
            <ContentGuide.Card>
                <ContentGuide.Header label={['Cadastros', 'Feriados']}>
                    <TextField
                        label="Ano"
                        size="small"
                        variant="filled"
                        className="w-48"
                        SelectProps={{
                            value: ano,
                        }}
                        onChange={({ target: { value } }) =>
                            setAno(Number(value))
                        }
                        select
                        fullWidth
                        onKeyDownCapture={e => e.stopPropagation()}
                    >
                        {anos.map(a => (
                            <MenuItem key={a} value={a}>
                                {a}
                                {a === new Date().getFullYear()
                                    ? ' (atual)'
                                    : ''}
                            </MenuItem>
                        ))}
                    </TextField>
                </ContentGuide.Header>
                <ContentGuide.DataGrid
                    columns={columns(ano)}
                    rows={data}
                    ToolbarProps={{
                        exportButtonProps: {
                            fileName: 'exportacao-feriados',
                        },
                        showQuickFilter: true,
                    }}
                    loading={isLoading}
                    onAdd
                />
            </ContentGuide.Card>
            <Outlet context={{ data }} />
        </ContentGuide>
    )
}

export function useFeriadosClienteOutletContext() {
    return useOutletContext<{ data?: FeriadosCliente[] }>()
}
